export default "__VITE_ASSET__DfYvQOpY__"